import { __assign } from 'tslib';
import * as React from 'react';
import { classNames, UitkContextProvider } from 'uitk-react-utils';
import { UitkCard } from './uitk-card.esm.js';
import styles from './uitk-cards.css';

/* Experimental/alpha extension of UitkCard, unstable */
var getClassNameList = classNames.bind(styles);
var UitkCardBrandTheme = function (props) {
    var children = props.children, className = props.className, _a = props.brandTheme, brandTheme = _a === void 0 ? 'dark' : _a;
    var baseClass = 'uitk-brand-theme-card';
    var cssClassNames = getClassNameList(className, baseClass, "".concat(baseClass, "-has-theme-").concat(brandTheme));
    return (React.createElement(UitkContextProvider, { config: {
            context: null,
            data: {
                contextClassNames: {
                    UitkHeading: "".concat(getClassNameList('uitk-brand-theme-card-heading'))
                }
            }
        } },
        React.createElement(UitkCard, __assign({}, props, { className: cssClassNames }), children)));
};
UitkCardBrandTheme.displayName = 'UitkCardBrandTheme';

export { UitkCardBrandTheme };
